// What a deal document is (TX-US-0043), mirrored from trex/documents/types.py; the API is the
// authority and lists them at /api/deal-vocabulary. A dropped file carries the type chosen when
// it was dropped: remembered against the File, so the upload queue need not know about types.

export const DOCUMENT_TYPES = [
  ['OFFER_QUOTE', 'Offer / quote'],
  ['SPECIFICATION', 'Specification'],
  ['APPROVAL_EVIDENCE', 'Approval evidence'],
  ['PURCHASE_ORDER', 'Purchase order'],
  ['SIGNED_CONTRACT', 'Signed contract'],
  ['AMENDMENT', 'Amendment'],
  ['BILL_OF_LADING', 'Bill of lading'],
  ['PACKING_LIST', 'Packing list'],
  ['CERTIFICATE_OF_ORIGIN', 'Certificate of origin'],
  ['INSPECTION_CERTIFICATE', 'Inspection / quality certificate'],
  ['INSURANCE_CERTIFICATE', 'Insurance certificate'],
  ['TRANSPORT_DOCUMENT', 'Transport document (CMR, waybill)'],
  ['UNLOADING_REPORT', 'Unloading report'],
  ['OWNERSHIP_TRANSFER', 'Ownership transfer certificate'],
  ['PROOF_OF_DELIVERY', 'Proof of delivery'],
  ['INVOICE', 'Invoice'],
  ['PROOF_OF_PAYMENT', 'Proof of payment'],
  ['PHOTO', 'Photo'],
  ['CORRESPONDENCE', 'Correspondence'],
  ['OTHER', 'Other'],
].map(([code, label]) => ({ code, label }));

export const DEFAULT_DOCUMENT_TYPE = 'OTHER';

export const typeLabel = (code) => DOCUMENT_TYPES.find((t) => t.code === code)?.label ?? code;

const chosen = new WeakMap();
export const rememberType = (file, code) => chosen.set(file, code);
export const typeOf = (file) => chosen.get(file) ?? DEFAULT_DOCUMENT_TYPE;
